import { memo } from "react";
import { createStyles, palette } from "../../../styles/theme";
import { Box } from "../Box";
import { SxProps } from "@mui/material";

const styles = createStyles({
  dot: {
    display: "inline-block",
  },
});

interface DotProps {
  color: string | "warning" | "error" | "success";
  size?: number;
  sx?: SxProps;
}

const Dot = ({ color, size = 7, sx }: DotProps) => {
  return (
    <Box
      sx={[
        styles.dot,
        {
          backgroundColor:
            color === "warning"
              ? "#e55200"
              : color === "error"
                ? "#FF0000"
                : color === "success"
                  ? palette.misc.successDot
                  : color,
          width: size,
          height: size,
          minWidth: size,
          minHeight: size,
          borderRadius: "50%",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};

export default memo(Dot);
